import React from "react";
import { useNavigate } from "react-router-dom";
import "../css/Properties.css";

const Main = () => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate("/documents");
  };

  return (
    <div className="properties-main">
      <div className="box1">
        <div className="left-side">
          <div className="left-side-header">
            <div>
              <img
                src="images/pdf.png"
                alt="Descriptive alt text"
                width="200"
                height="200"
              />
            </div>
            <div className="left-side-text">
              <div className="title">PM2100124-LTG531-ER2-00004_Rev4.pdf</div>
              <div className="subtitle">(13.0 MB)</div>
            </div>
          </div>
          <div className="left-side-buttons">
            <div className="button1">
              <div className="download">Download File</div>
            </div>
            <div className="button2">
              <div className="text">Download with Markup Summary</div>
              <div className="icon-arrow">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                  stroke="#181818"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M 4.5 7.25 L 9 11.75 L 13.5 7.25" />
                </svg>
              </div>
            </div>
          </div>
        </div>
        <div className="right-side">
            <div className="row">
                <div className="col">
                    <div className="property-title">Type</div>
                    <div className="property-value">Report</div>
                </div>
                <div className="col">
                    <div className="property-title">Revision</div>
                    <div className="property-value">04</div>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <div className="property-title">Status</div>
                    <div className="property-value">Code 4</div>
                </div>
                <div className="col">
                    <div className="property-title">Discipline</div>
                    <div className="property-value">ELE-Electrical</div>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <div className="property-title">Release Purpose</div>
                    <div className="property-value">IFR-Issued for Review</div>
                </div>
                <div className="col">
                    <div className="property-title">Organization Code</div>
                    <div className="property-value">LTG</div>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <div className="property-title">Unit Code</div>
                    <div className="property-value">531 - PV Group 1</div>
                </div>
                <div className="col">
                    <div className="property-title">Element</div>
                    <div className="property-value">PM210012:NGHP – Power Elements (PWE)</div>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <div className="property-title">Document Class</div>
                    {/* <div className="property-value">Report</div> */}
                </div>
                <div className="col">
                    <div className="property-title">Construction work Package (CWP)</div>
                    {/* <div className="property-value">Report</div> */}
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <div className="property-title">Work Package Area (WPA)</div>
                    {/* <div className="property-value">Report</div> */}
                </div>
                <div className="col">
                    <div className="property-title">Equipment Tag</div>
                    {/* <div className="property-value">Report</div> */}
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <div className="property-title">Confidential</div>
                    {/* <div className="property-value">Report</div> */}
                </div>
                <div className="col">
                    <div className="property-title">Client/3rd Party Document Number</div>
                    <div className="property-value">PM210012:NGHP – Power Elements (PWE)</div>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <div className="property-title">Revision Date</div>
                    <div className="property-value">06/18/2025</div>
                </div>
                <div className="col">
                    <div className="property-title">Milestone Date</div>
                    {/* <div className="property-value">Report</div> */}
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <div className="property-title">Planned Submission Date</div>
                    <div className="property-value">06/24/2025</div>
                </div>
                <div className="col">
                    <div className="property-title">Originator</div>
                    <div className="property-value">LARSEN & TOUBRO SAUDI ARABIA LLC</div>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <div className="property-title">Comments</div>
                    {/* <div className="property-value">Report</div> */}
                </div>
                <div className="col">
                    <div className="property-title">KKS Identification</div>
                    {/* <div className="property-value">Report</div> */}
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <div className="property-title">VDR Codes & Descriptions</div>
                    {/* <div className="property-value">Report</div> */}
                </div>
                <div className="col">
                    <div className="property-title">Client/3rd Party Document Number</div>
                    {/* <div className="property-value">Report</div> */}
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <div className="property-title">Vendor or Internal Document Number</div>
                    {/* <div className="property-value">06/24/2025</div> */}
                </div>
                <div className="col">
                    <div className="property-title">Vendor or Internal Document Revision</div>
                    {/* <div className="property-value">LARSEN & TOUBRO SAUDI ARABIA LLC</div> */}
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <div className="property-title">Commissioning System ID</div>
                    {/* <div className="property-value">06/24/2025</div> */}
                </div>
                <div className="col">
                    <div className="property-title">As Built Required</div>
                    <div className="property-value">No</div>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <div className="property-title">PO Number</div>
                    {/* <div className="property-value">06/24/2025</div> */}
                </div>
                <div className="col">
                    <div className="property-title">OT integration Status</div>
                    {/* <div className="property-value">LARSEN & TOUBRO SAUDI ARABIA LLC</div> */}
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <div className="property-title">Date Created</div>
                    {/* <div className="property-value">06/24/2025</div> */}
                </div>
                <div className="col">
                    <div className="property-title">Requisition ID</div>
                    {/* <div className="property-value">LARSEN & TOUBRO SAUDI ARABIA LLC</div> */}
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <div className="property-title">Review Source</div>
                    <div className="property-value">WF - 017411</div>
                </div>
                <div className="col">
                    <div className="property-title">Review Status</div>
                    <div className="property-value">CODE 4 - No Comments</div>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <div className="property-title">Version</div>
                    <div className="property-value">21</div>
                </div>
            </div>
        </div>
      </div>
    </div>
  );
};

export default Main;